import estilos from "./Rodape.module.css";

const Rodape = () => {
  return (
    <footer className={estilos.rodape}>
      <p className={estilos.texto}>
        © 2025 <span className={estilos.destaque}>Walter Fonseca Neto</span>. Todos os direitos reservados.
      </p>
    </footer>
  );
};

export default Rodape;
